const API_URL ='https://apimantenimiento.hagemsa.com:7445/hgapi';  //'https://apimantenimiento.hagemsa.com:7445/hgapi';

function mockDelay(data, ms = 600) {
    return new Promise(resolve => setTimeout(() => resolve(data), ms));
}

function mockResumen(placa) {
    return {
        placa,
        ultimoMantenimiento: {
            nroOrden: 'OT-2024-1832',
            fecha: '2024-10-15',
            tipo: 'Preventivo 250h',
            descripcion: 'Cambio de aceite motor, filtros de aire y combustible, revisión de frenos',
            tecnico: 'Carlos Mendoza',
            km: 145230,
        },
        proximoMantenimiento: {
            fecha: '2025-02-15',
            tipo: 'Preventivo 500h',
            km: 160000,
            diasRestantes: 58,
            // 'vigente' | 'proximo' (<=30 días) | 'vencido'
            estado: 'vigente',
        },
    };
}

function mockHistorial(placa) {
    return {
        placa,
        historial: [
            {
                nroOrden: 'OT-2024-1832',
                fecha: '2024-10-15',
                tipo: 'Preventivo 250h',
                descripcion: 'Cambio de aceite motor, filtros de aire y combustible, revisión de frenos',
                tecnico: 'Carlos Mendoza',
                km: 145230,
            },
            {
                nroOrden: 'OT-2024-1541',
                fecha: '2024-07-20',
                tipo: 'Correctivo',
                descripcion: 'Reparación de sistema de frenos traseros y calibración',
                tecnico: 'Roberto Silva',
                km: 138100,
            },
            {
                nroOrden: 'OT-2024-1203',
                fecha: '2024-04-08',
                tipo: 'Preventivo 250h',
                descripcion: 'Cambio de aceite motor, filtros de aire y combustible',
                tecnico: 'Carlos Mendoza',
                km: 130450,
            },
            {
                nroOrden: 'OT-2023-2891',
                fecha: '2024-01-15',
                tipo: 'Preventivo 500h',
                descripcion: 'Mantenimiento mayor: aceite, filtros, correas, revisión eléctrica',
                tecnico: 'Luis Torres',
                km: 122800,
            },
        ],
        alertas: [
            {
                nivel: 'info',
                mensaje: 'Próximo mantenimiento preventivo programado en 58 días (15/02/2025)',
            },
        ],
    };
}

export const mantenimientoService = {
    getResumenXPlaca(placa) {
        return fetch(`${API_URL}/mantenimiento_preventivo`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ placa }),
        })
            .then(r => r.json())
            .catch(() => null);
    },

    getHistorialXPlaca(placa) {
        return mockDelay(mockHistorial(placa));
    },

    getUltimosMantenimientos(placa) {
        return fetch(`${API_URL}/ultimos_mantenimientos`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ placa }),
        })
            .then(r => r.json())
            .catch(() => null);
    },
};
